import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import { TenantsQueryFilters } from '../../features/offices/OfficesSlice';

export function fetchAllTenants(ownersFilter: TenantsQueryFilters) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: ownersFilter,
  };

  return axios
    .get('/tenant/tenants/getalltenants', config)
    .then(res => {
      // console.error(res);
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchTenantDetails(tenantId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { tenantId },
  };

  return axios.get('/tenant/tenants/gettenantdetails', config).then(res => {
    return res.data;
  });
}
export function fetchSiteDetails(sitetId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { sitetId },
  };

  return axios.get('/identity/sites/getsitedetailsbyid', config).then(res => {
    return res;
  });
}
export function updateTenant(tenantUpdateData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/tenant/tenants/updatetenant', tenantUpdateData, config)
    .then(res => {
      return res.data;
    });
}
